import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-skipback",
  "use": "icon-th-skipback-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-skipback\">\n<path d=\"M24.9762 4.25002C24.6639 4.07694 24.3109 3.99064 23.9539 4.00009C23.5969 4.00954 23.249 4.1144 22.9463 4.30377L8 13.6538V5.00002C8 4.73481 7.89464 4.48045 7.70711 4.29292C7.51957 4.10538 7.26522 4.00002 7 4.00002C6.73478 4.00002 6.48043 4.10538 6.29289 4.29292C6.10536 4.48045 6 4.73481 6 5.00002V27C6 27.2652 6.10536 27.5196 6.29289 27.7071C6.48043 27.8947 6.73478 28 7 28C7.26522 28 7.51957 27.8947 7.70711 27.7071C7.89464 27.5196 8 27.2652 8 27V18.3463L22.9463 27.6938C23.2472 27.8827 23.5933 27.9878 23.9485 27.9981C24.3038 28.0084 24.6553 27.9235 24.9667 27.7523C25.2782 27.5811 25.5382 27.3298 25.7199 27.0243C25.9015 26.7189 25.9982 26.3704 26 26.015V5.98502C26 5.63074 25.905 5.28293 25.7249 4.9778C25.5449 4.67267 25.2864 4.42136 24.9762 4.25002ZM24 26L8.02 16L24 6.00877V26Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-skipback.svg
// module id = f33H
// module chunks = 83